const Home = () => {
  return (
    <p>.</p>
  );
};

export default Home;
